import { BASE_API_URL } from './index';
export const ANNOUNCEMENT_BASE_ENDPOINT = `${BASE_API_URL}/user_feature_announcements/`;
export const ANNOUNCEMENT_UPDATE_ENDPOINT = `${ANNOUNCEMENT_BASE_ENDPOINT}mark_as_seen/`;
